<template>
  <div class="WCaborder">
    <div class="breadcrumb-container">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/wContainer' }">柜子列表</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: `/cabinetDetail/${cabData.containerId}` }">柜子详情</el-breadcrumb-item>
        <el-breadcrumb-item>订单详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    
    <div class="WCabdetails">
      
      <el-card class="unified-form-card" shadow="hover" :body-style="{ padding: '15px 20px' }">
        <div class="card-title">基本信息与规格</div>
        
        <div class="form-grid-6col">
          
          <div class="grid-item">
            <span class="label">唛头:</span>
            <el-input disabled v-model="cabData.mark" size="mini" class="input-content"></el-input>
          </div>
          
          <div class="grid-item">
            <span class="label">目的仓:</span>
            <el-input disabled v-model="cabData.fbacode" size="mini" class="input-content"></el-input>
          </div>
          
          <div class="grid-item">
            <span class="label">FBA#:</span>
            <el-input disabled v-model="cabData.fbaId" size="mini" class="input-content"></el-input>
          </div>
          
          <div class="grid-item">
            <span class="label">Ref ID:</span>
            <el-input disabled v-model="cabData.fbaPo" size="mini" class="input-content"></el-input>
          </div>
          
          <div class="grid-item">
            <span class="label">派送方式:</span>
            <el-input disabled v-model="cabData.truckType" size="mini" class="input-content"></el-input>
          </div>
          
          <div class="grid-item">
            <span class="label">件数:</span>
            <el-input disabled v-model="cabData.cnt" type="number" size="mini" class="input-content"></el-input>
          </div>
          
          <div class="grid-item">
            <span class="label">重量(KG):</span>
            <el-input disabled v-model="cabData.kg" type="number" size="mini" class="input-content"></el-input>
          </div>
          
          <div class="grid-item">
            <span class="label">体积(CBM):</span>
            <el-input disabled v-model="cabData.cbm" type="number" size="mini" class="input-content"></el-input>
          </div>

          <div class="grid-item">
            <span class="label">数量:</span>
            <el-input disabled v-model="cabData.qty" type="number" size="mini" class="input-content"></el-input>
          </div>
          
          <div class="grid-item">
            <span class="label">是否贴标:</span>
            <el-input disabled :value="cabData.operateType === '1' ? '是' : '否'" size="mini" class="input-content"></el-input>
          </div>

          <div class="grid-item">
            <span class="label">贴标要求:</span>
            <el-input disabled v-model="cabData.operateRule" type="textarea" :rows="1" size="mini" class="input-content"></el-input>
          </div>

          <div class="grid-item">
            <span class="label">创建时间:</span>
            <el-input disabled v-model="cabData.createTime" size="mini" class="input-content"></el-input>
          </div>
          
        </div>
        
      </el-card>

      <el-card class="table-card" shadow="hover" :body-style="{ padding: '15px 20px' }">
        <div class="card-title">产品明细列表</div>

        <div class="table-wrapper">
          <el-table
            :data="orderData"
            style="width: 100%"
            border
            stripe
            size="mini"
          >
            <el-table-column prop="tailNo" label="单号" width="240" align="center"></el-table-column>
            <el-table-column prop="ctn" label="箱数" width="80" align="center"></el-table-column>
            <el-table-column prop="qty" label="单箱数量" width="80" align="center"></el-table-column>
            
            <el-table-column prop="sku" label="SKU" width="120" align="center"></el-table-column>
            <el-table-column prop="fba" label="FBA" width="100" align="center"></el-table-column>
            <el-table-column prop="poNo" label="PO#" width="100" align="center"></el-table-column>
            <el-table-column prop="goodsName" label="商品名" width="150" align="center"></el-table-column>
            <el-table-column prop="mode" label="型号" width="100" align="center"></el-table-column>
            
            <el-table-column prop="goodsPic" label="图片" width="70" align="center">
              <template slot-scope="scope">
                <div v-if="scope.row.goodsPic" class="img-preview-box">
                  <el-image 
                    style="width: 40px; height: 40px"
                    :src="scope.row.goodsPic" 
                    :preview-src-list="[scope.row.goodsPic]"
                    fit="cover">
                  </el-image>
                </div>
                <span v-else>-</span>
              </template>
            </el-table-column>

            <el-table-column prop="fbaAddress" label="FBA仓库地址" width="150" align="center"></el-table-column>
            <el-table-column prop="packageMark" label="包装标记" width="90" align="center"></el-table-column>
            
            <el-table-column prop="newPic" label="区分图片" width="70" align="center">
              <template slot-scope="scope">
                <div v-if="scope.row.newPic" class="img-preview-box">
                  <el-image 
                    style="width: 40px; height: 40px"
                    :src="scope.row.newPic" 
                    :preview-src-list="[scope.row.newPic]"
                    fit="cover">
                  </el-image>
                </div>
                <span v-else>-</span>
              </template>
            </el-table-column>

            <el-table-column prop="remark" label="备注" min-width="120" align="center"></el-table-column>
            
          </el-table>
        </div>
      </el-card>

    </div>
  </div>
</template>

<script>
import orderTailApi from "../../http/wcOrderTail";
import { formatTimeToStr } from "../../util/toLocaleString";

export default {
  name: "WorderDetials",
  data() {
    return {
      tailId: 0,
      cabData: {
        id: "",
        mark: '',
        fbacode: '',
        fbaId: '',
        fbaPo: '',
        truckType: '',
        productNameCn: '',
        mode: '',
        cnt: 0,
        kg: 0,
        cbm: 0,
        qty: 0,
        fbaNo: '',
        markNo: '',
        operateType: '',
        operateRule: '',
        sku: '',
        createTime: '',
        containerId: ''
      },
      orderData: [],
    };
  },
  created() {
    this.tailId = this.$route.params.id;
    this.initData();
  },
  methods: {
    async initData() {
        if (this.tailId != 0) {
            await this.loadCabinetData();
            await this.loadOrderList();
        }
    },
    
    async loadCabinetData() {
      try {
        const response = await orderTailApi.contOrdertailById({ 
            params: { id: this.tailId }  
        });
        if (response.data.code === "ok") {
            var date = new Date(response.data.data.createTime * 1000);
            const createTime = formatTimeToStr(date, "yyyy-MM-dd hh:mm:ss");
            this.cabData = { 
              ...this.cabData, 
              ...response.data.data, 
              createTime: createTime 
            };
        }
      } catch (error) {
        console.error('加载订单数据失败:', error);
        this.$message.error('加载订单数据失败');
      }
    },
    
    async loadOrderList() {
      try {
        const response = await orderTailApi.conttaildetailList({ 
            params: { id: this.tailId }  
        });
        if (response.data.code === "ok") {
          this.orderData = response.data.data || [];
        }
      } catch (error) {
        console.error('加载订单明细失败:', error);
        this.$message.error('加载订单明细失败');
      }
    },
  }
};
</script>

<style lang="less" scoped>
/* 全局容器 */
.WCaborder {
  padding: 15px;
  background-color: #f0f2f5;
  min-height: 100vh;
  .breadcrumb-container { margin-bottom: 12px; padding-left: 2px; }
}

.unified-form-card, .table-card { 
  margin-bottom: 12px; 
  border: none; 
  border-radius: 4px; 
}

.card-title { 
  font-size: 15px; 
  font-weight: 600; 
  color: #303133; 
  margin-bottom: 15px; 
  padding-left: 8px; 
  border-left: 4px solid #409eff; 
  line-height: 1.2; 
}

/* 6列栅格布局 */
.form-grid-6col {
    display: flex;
    flex-wrap: wrap;
    margin-right: -10px; 
    .grid-item {
        width: 16.666%; 
        padding-right: 10px;
        margin-bottom: 15px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        .label { 
          width: 70px; 
          font-size: 12px; 
          color: #606266; 
          margin-right: 6px; 
          text-align: right; 
          flex-shrink: 0; 
        }
        .input-content {
            flex: 1; 
            /deep/ .el-input__inner { 
              text-align: left; 
              background-color: #f5f7fa;
              color: #606266;
            }
        }
    }
}

/* 表格样式 */
.table-wrapper {
  /deep/ .el-table {
    .el-table__header-wrapper th { 
      background-color: #f7f8fa; 
      color: #303133; 
      padding: 8px 0; 
      font-size: 13px; 
      font-weight: 600; 
    }
    .el-table__body-wrapper td { 
      padding: 8px 0; 
    }
    .el-table__body tr:hover > td { 
      background-color: #f5f5f5 !important; 
    }
    .img-preview-box {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}

/* 图片预览样式 */
.img-preview-box {
  display: flex;
  justify-content: center;
  align-items: center;
  .el-image {
    cursor: pointer;
    &:hover {
      opacity: 0.8;
    }
  }
}

/* 媒体查询 */
@media (max-width: 1700px) { 
  .form-grid-6col .grid-item { width: 20%; } 
}
@media (max-width: 1400px) { 
  .form-grid-6col .grid-item { width: 25%; } 
}
@media (max-width: 992px) { 
  .form-grid-6col .grid-item { width: 33.333%; } 
}
@media (max-width: 768px) { 
  .form-grid-6col .grid-item { width: 50%; .label { width: 80px; } }
}
</style>